// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import * as WrapperCore from '@angular/core';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
import * as WrapperServices from '../generated/api/adminAudit.service';
// </generated-client-wrappers:imports>
import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import { AdminAuditEventResponse, AdminAuditQuery, AdminAuditSummary, PagedResult } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AdminAuditClientService {
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);
  private readonly http = inject(HttpClient);

  getAuditSummary(query: AdminAuditQuery): Observable<AdminAuditSummary> {
    return this.http.post<AdminAuditSummary>(OperationsApiRoutes.auditSummary, query, {
      context: this.quietContext,
    });
  }

  queryAudit(query: AdminAuditQuery): Observable<PagedResult<AdminAuditEventResponse>> {
    return this.http.post<PagedResult<AdminAuditEventResponse>>(OperationsApiRoutes.auditQuery, query, {
      context: this.quietContext,
    });
  }
  // <generated-client-wrappers:methods>
  private readonly wrapperGeneratedClient = WrapperCore.inject(
    WrapperServices.AdminAuditService,
    { optional: true },
  );

  query(
    query: WrapperApi.AdminAuditQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ObservabilityPageOfAdminAuditEventResponse> {
    if (!this.wrapperGeneratedClient)
      throw new Error('AdminAuditService is not available');
    return this.wrapperGeneratedClient.adminAuditQuery(
      query,
      'body',
      reportProgress,
      options,
    );
  }

  summary(
    query: WrapperApi.AdminAuditQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AdminAuditSummaryResponse> {
    if (!this.wrapperGeneratedClient)
      throw new Error('AdminAuditService is not available');
    return this.wrapperGeneratedClient.adminAuditSummary(
      query,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
